import Vue from "vue";
import axios from "axios";
import Chakra, { CThemeProvider, CReset, CBox } from "@chakra-ui/vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
// import "vue-toast-notification/dist/theme-default.css";
import "../src/assets/styles/tailwind.css";
import "../src/assets/styles/default.css";
// import * as VueGoogleMaps from 'vue2-google-maps'

require("@/store/subscriber");
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.use(Chakra);
Vue.use(VueToast);
Vue.config.productionTip = false;

store.dispatch("auth/setUser", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    render: h => h(CThemeProvider, [h(CBox, [h(CReset), h(App)])])
  }).$mount("#app");
});
